(function(){
"use strict";
var guideRoot = document.getElementById("guia-esp");
if(!guideRoot) return;
var $ = function(sel,ctx){ return (ctx||guideRoot).querySelector(sel); };
var $$ = function(sel,ctx){ return Array.prototype.slice.call((ctx||guideRoot).querySelectorAll(sel)); };
var PRODUTOS = [
  {nome:"Garibaldi Espumante Moscatel", url:"/products/espumante-moscatel-garibaldi-750ml", estilo:"moscatel", cor:"branco", metodo:"Asti", regiao:"Serra Gaúcha", harmonia:"sobremesas, frutas e panetone"},
  {nome:"Vita Eterna Espumante Moscatel", url:"/products/vita-eterna-espumante-moscatel", estilo:"moscatel", cor:"branco", metodo:"Asti", regiao:"Serra Gaúcha", harmonia:"doces e tábuas de queijos"},
  {nome:"Garibaldi Espumante Moscatel Rosé", url:"/products/espumante-moscatel-rose-garibaldi-750ml", estilo:"moscatel", cor:"rose", metodo:"Asti", regiao:"Serra Gaúcha", harmonia:"frutas vermelhas e chocolate branco"},
  {nome:"Casa Valduga Naturelle Espumante Moscatel Rosé", url:"/products/espumante-moscatel-rose-naturelle-casa-valduga-750ml", estilo:"moscatel", cor:"rose", metodo:"Asti", regiao:"Serra Gaúcha", harmonia:"sobremesas cítricas e frutas"},
  {nome:"Del Grano Espumante Moscatel Rosé", url:"/products/del-grano-espumante-moscatel-rose", estilo:"moscatel", cor:"rose", metodo:"Asti", regiao:"Serra Gaúcha", harmonia:"salada de frutas e pavlova"},
  {nome:"Monte Paschoal Espumante Moscatel Rosé", url:"/products/monte-paschoal-espumante-moscatel-rose", estilo:"moscatel", cor:"rose", metodo:"Asti", regiao:"Farroupilha (RS)", harmonia:"doces natalinos"},
  {nome:"Zanotto Espumante Brut Champenoise", url:"/products/zanotto-espumante-brut-champenoise", estilo:"brut-tradicional", cor:"branco", metodo:"Tradicional", regiao:"Campos de Cima da Serra (RS)", harmonia:"queijos, aves e risotos"},
  {nome:"Casa Valduga Premivm Espumante Nature (caixa c/ 6)", url:"/products/casa-valduga-premivm-espumante-nature-caixa-com-6", estilo:"nature", cor:"branco", metodo:"Tradicional", regiao:"Vale dos Vinhedos (RS)", harmonia:"ostras, sushi e frutos do mar"},
  {nome:"Garibaldi Zero Álcool 0,0% Moscato Rosé", url:"/products/espumante-moscato-rose-zero-alcool-garibaldi-750ml", estilo:"semalcool", cor:"rose", metodo:"Sem álcool", regiao:"Serra Gaúcha", harmonia:"brindes inclusivos e frutas"},
  {nome:"Garibaldi ICE Zero Álcool Espumante Rosé", url:"/products/zero-alcool-ice-rose-garibaldi-750ml", estilo:"semalcool", cor:"rose", metodo:"Sem álcool", regiao:"Serra Gaúcha", harmonia:"dias quentes, com gelo"},
  {nome:"Kit Espumantes 130 Casa Valduga", url:"/products/kit-espumantes-130-casa-valduga", estilo:"kit", cor:"misto", metodo:"Tradicional", regiao:"Vale dos Vinhedos (RS)", harmonia:"presentes e degustações comparativas"}
];
var COLECOES = {
  espumantes:{nome:"Todos os espumantes", url:"/collections/espumantes"},
  proseccos:{nome:"Proseccos brasileiros", url:"/collections/proseccos"},
  semalcool:{nome:"Espumantes sem álcool", url:"/collections/sem-alcool"},
  caixas:{nome:"Caixas de espumantes", url:"/collections/espumantes-em-caixa"},
  minis:{nome:"Mini espumantes", url:"/collections/mini-espumantes"},
  garibaldi:{nome:"Vinícola Garibaldi", url:"/collections/garibaldi"},
  valduga:{nome:"Casa Valduga", url:"/collections/casa-valduga"}
};
function cardProduto(p){
  var productUrl = p.url.indexOf("/")===0 ? "https://espumantesdosul.com.br"+p.url : p.url;
  return '<div class="prod-card">'+
    '<span class="p-ico" aria-hidden="true"><svg width="26" height="40" viewBox="0 0 26 40"><path d="M10 1 h6 v8 c4 3 6 6 6 12 v14 a4 4 0 0 1 -4 4 h-10 a4 4 0 0 1 -4 -4 v-14 c0 -6 2 -9 6 -12 z" fill="none" stroke="currentColor" stroke-width="1.6"/></svg></span>'+
    '<b>'+p.nome+'</b>'+
    '<small>'+p.metodo+' · '+p.regiao+'</small>'+
    '<small>Vai bem com: '+p.harmonia+'</small>'+
    '<a href="'+productUrl+'" target="_blank" rel="noopener" title="Página do produto '+p.nome+'">Conhecer este espumante ↗</a>'+
  '</div>';
}
function porEstilo(estilos, limite){
  var out = [];
  estilos.forEach(function(e){
    PRODUTOS.forEach(function(p){ if(p.estilo===e && out.indexOf(p)<0) out.push(p); });
  });
  return out.slice(0, limite||3);
}
function escProduto(valor){
  return String(valor==null ? "" : valor).replace(/[&<>"']/g,function(caractere){
    return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;"}[caractere];
  });
}
function moedaProduto(valor){
  var numero = Number(valor);
  if(!Number.isFinite(numero)) return "";
  var moeda = guideRoot.getAttribute("data-currency") || "BRL";
  return new Intl.NumberFormat("pt-BR",{style:"currency",currency:moeda}).format(numero);
}
function cardProdutoLoja(produto){
  var imagem = produto.featured_image && produto.featured_image.url ? produto.featured_image.url : produto.image;
  var alt = produto.featured_image && produto.featured_image.alt ? produto.featured_image.alt : produto.title;
  var preco = moedaProduto(produto.price_min || produto.price);
  var comparacaoNumero = Number(produto.compare_at_price_min || produto.compare_at_price_max || 0);
  var precoNumero = Number(produto.price_min || produto.price || 0);
  var comparacao = comparacaoNumero > precoNumero ? moedaProduto(comparacaoNumero) : "";
  return '<article class="prod-card prod-card--live">'+
    '<a class="prod-image" href="'+escProduto(produto.url)+'" target="_blank" rel="noopener" aria-label="Ver '+escProduto(produto.title)+'">'+
      (imagem ? '<img src="'+escProduto(imagem)+'" alt="'+escProduto(alt)+'" loading="lazy" width="480" height="480">' : '<span class="p-ico" aria-hidden="true">🍾</span>')+
    '</a><div class="prod-card-body">'+
      (produto.vendor ? '<span class="prod-vendor">'+escProduto(produto.vendor)+'</span>' : '')+
      '<b>'+escProduto(produto.title)+'</b>'+
      (preco ? '<div class="prod-price"><span>'+preco+'</span>'+(comparacao ? '<s>'+comparacao+'</s>' : '')+'</div>' : '')+
      '<a class="prod-card-link" href="'+escProduto(produto.url)+'" target="_blank" rel="noopener">Ver produto na loja ↗</a>'+
    '</div></article>';
}
function termosBuscaProduto(estilo){
  var texto = String(estilo||"").toLowerCase();
  if(texto.indexOf("sem álcool")>-1 || texto.indexOf("0,0")>-1) return ["sem álcool"];
  if(texto.indexOf("moscatel")>-1) return ["moscatel"];
  if(texto.indexOf("rosé")>-1 || texto.indexOf("rose")>-1) return ["brut rosé","brut"];
  if(texto.indexOf("prosecco")>-1) return ["prosecco","brut"];
  if(texto.indexOf("extra brut")>-1) return ["extra brut","brut"];
  if(texto.indexOf("nature")>-1) return ["nature","brut"];
  if(texto.indexOf("blanc de noirs")>-1) return ["blanc de noirs","brut"];
  if(texto.indexOf("blanc de blancs")>-1) return ["blanc de blancs","brut"];
  if(texto.indexOf("demi-sec")>-1 || texto.indexOf("demi sec")>-1) return ["demi-sec","moscatel"];
  return ["brut"];
}
var buscaProdutosController = null;
async function buscarProdutosLoja(termos,limite){
  if(buscaProdutosController) buscaProdutosController.abort();
  buscaProdutosController = new AbortController();
  var encontrados = [];
  var ids = {};
  var raizLoja = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
  for(var i=0;i<termos.length && encontrados.length<limite;i++){
    var parametros = new URLSearchParams();
    parametros.set("q",termos[i]);
    parametros.set("resources[type]","product");
    parametros.set("resources[limit]",String(limite));
    parametros.set("resources[options][unavailable_products]","hide");
    var resposta = await fetch(raizLoja+"search/suggest.json?"+parametros.toString(),{headers:{Accept:"application/json"},signal:buscaProdutosController.signal});
    if(!resposta.ok) throw new Error("Busca de produtos indisponível");
    var dados = await resposta.json();
    var produtos = dados && dados.resources && dados.resources.results ? dados.resources.results.products || [] : [];
    produtos.forEach(function(produto){
      if(!ids[produto.id] && encontrados.length<limite){ ids[produto.id]=true; encontrados.push(produto); }
    });
  }
  return encontrados;
}
function prepararProdutosCaixa(){
  var prateleira = $("#calc-box-products");
  if(!prateleira) return;
  var produtos = $$("[data-box-product]",prateleira);
  for(var i=produtos.length-1;i>0;i--){
    var sorteado = Math.floor(Math.random()*(i+1));
    var temporario = produtos[i];
    produtos[i] = produtos[sorteado];
    produtos[sorteado] = temporario;
  }
  produtos.forEach(function(produto,indice){
    if(indice<3){
      produto.hidden = false;
      prateleira.appendChild(produto);
    }else{
      produto.remove();
    }
  });
}
prepararProdutosCaixa();

var HARM = {
  canapes:{estilo:"Brut", just:"Acidez e borbulha renovam o paladar entre mordidas salgadas e untuosas.", temp:"6–8 °C", metodo:"Charmat ou Tradicional", prods:["brut-tradicional"], col:"espumantes"},
  "queijos-frescos":{estilo:"Prosecco ou Brut leve", just:"Delicadeza com delicadeza: fruta fresca acompanha queijos suaves e folhas.", temp:"6–8 °C", metodo:"Charmat", prods:[], col:"proseccos"},
  embutidos:{estilo:"Extra Brut ou Brut Rosé", just:"Sal e gordura pedem acidez firme; a fruta vermelha do rosé conversa com embutidos.", temp:"6–8 °C", metodo:"Charmat ou Tradicional", prods:["brut-tradicional"], col:"espumantes"},
  ostras:{estilo:"Nature (Blanc de Blancs)", just:"Mineralidade e secura espelham o iodado da ostra sem sobrepor nada.", temp:"7–9 °C", metodo:"Tradicional", prods:["nature"], col:"espumantes"},
  camarao:{estilo:"Brut ou Brut Rosé", just:"Corpo suficiente para crustáceos grelhados, frescor para o mar.", temp:"6–8 °C", metodo:"Charmat ou Tradicional", prods:["brut-tradicional"], col:"espumantes"},
  sushi:{estilo:"Brut cítrico ou Nature", just:"Acidez limpa o paladar entre peças; delicadeza respeita o peixe cru.", temp:"6–8 °C", metodo:"Charmat ou Tradicional", prods:["nature"], col:"proseccos"},
  "peixe-frito":{estilo:"Extra Brut", just:"A borbulha faz o papel do limão: corta a fritura e refresca.", temp:"6–8 °C", metodo:"Charmat", prods:[], col:"espumantes"},
  "peixe-grelhado":{estilo:"Brut ou Blanc de Blancs", just:"Frescor e elegância acompanham a delicadeza do peixe no ponto.", temp:"6–8 °C", metodo:"Tradicional ou Charmat", prods:["brut-tradicional"], col:"espumantes"},
  frango:{estilo:"Brut ou Brut Rosé", just:"Versatilidade para assados e grelhados de sabor médio.", temp:"6–8 °C", metodo:"Charmat ou Tradicional", prods:["brut-tradicional"], col:"espumantes"},
  pato:{estilo:"Blanc de Noirs ou rosé estruturado", just:"Carnes mais gordas e saborosas pedem corpo e fruta vermelha.", temp:"8–10 °C", metodo:"Tradicional", prods:["brut-tradicional"], col:"valduga"},
  "carne-leve":{estilo:"Rosé estruturado ou Blanc de Noirs", just:"Estrutura para a proteína, acidez para o azeite e o sal do carpaccio.", temp:"8–10 °C", metodo:"Tradicional", prods:[], col:"espumantes"},
  "massa-branca":{estilo:"Brut", just:"A mousse cremosa espelha o molho; a acidez impede que canse.", temp:"6–8 °C", metodo:"Tradicional ou Charmat", prods:["brut-tradicional"], col:"espumantes"},
  "massa-tomate":{estilo:"Brut Rosé", just:"Acidez do tomate encontra acidez do vinho; fruta vermelha com fruta vermelha.", temp:"6–8 °C", metodo:"Charmat", prods:[], col:"espumantes"},
  risoto:{estilo:"Método tradicional Brut", just:"Notas de autólise ecoam o umami de cogumelos e queijos; cítricos pedem Nature.", temp:"8–10 °C", metodo:"Tradicional", prods:["brut-tradicional","nature"], col:"valduga"},
  pizza:{estilo:"Brut ou Brut Rosé", just:"Massa, queijo e molho: o trio pede acidez, borbulha e fruta.", temp:"6–8 °C", metodo:"Charmat", prods:[], col:"espumantes"},
  "pizza-doce":{estilo:"Moscatel", just:"Doçura compatível com banana, chocolate e canela.", temp:"4–6 °C", metodo:"Asti", prods:["moscatel"], col:"espumantes"},
  frituras:{estilo:"Brut ou Extra Brut bem gelado", just:"Acidez + carbonatação 'raspam' a gordura e devolvem o apetite.", temp:"6–8 °C", metodo:"Charmat", prods:["brut-tradicional"], col:"espumantes"},
  churrasco:{estilo:"Brut Rosé", just:"Fruta vermelha e acidez para linguiça, frango e cortes suínos; estrutura para a carne.", temp:"6–8 °C", metodo:"Charmat ou Tradicional", prods:[], col:"espumantes"},
  feijoada:{estilo:"Extra Brut ou Brut Rosé", just:"Prato intenso e gordo pede contraponto seco, gelado e refrescante.", temp:"6–8 °C", metodo:"Charmat ou Tradicional", prods:["brut-tradicional"], col:"espumantes"},
  moqueca:{estilo:"Brut Rosé ou Sec", just:"Dendê e pimenta se acalmam com fruta e um toque de dulçor.", temp:"6–8 °C", metodo:"Charmat", prods:[], col:"espumantes"},
  paodequeijo:{estilo:"Brut da Serra Gaúcha", just:"Herança colonial com espumante da Serra: afinidade histórica e sensorial.", temp:"6–8 °C", metodo:"Charmat ou Tradicional", prods:["brut-tradicional"], col:"garibaldi"},
  asiatica:{estilo:"Sec, Demi-Sec ou Moscatel", just:"Quanto mais pimenta e açúcar no prato, mais dulçor no espumante.", temp:"4–6 °C", metodo:"Charmat ou Asti", prods:["moscatel"], col:"espumantes"},
  "queijos-moles":{estilo:"Brut de método tradicional", just:"Autólise conversa com a casca florida; acidez corta a cremosidade.", temp:"8–10 °C", metodo:"Tradicional", prods:["brut-tradicional"], col:"valduga"},
  "queijos-duros":{estilo:"Extra Brut ou Nature", just:"Sal e cristais de maturação pedem secura e acidez.", temp:"7–9 °C", metodo:"Tradicional", prods:["nature"], col:"espumantes"},
  "queijo-azul":{estilo:"Demi-Sec ou Moscatel", just:"Doce com salgado: o contraste clássico que suaviza o mofo azul.", temp:"4–6 °C", metodo:"Asti", prods:["moscatel"], col:"espumantes"},
  "queijo-colonial":{estilo:"Brut", just:"Vizinhos de origem na Serra, parceiros naturais de mesa.", temp:"6–8 °C", metodo:"Charmat", prods:[], col:"garibaldi"},
  frutas:{estilo:"Moscatel", just:"Aromas de uva, flores e mel abraçam a fruta fresca; álcool leve mantém a tarde leve.", temp:"4–6 °C", metodo:"Asti", prods:["moscatel"], col:"espumantes"},
  tortas:{estilo:"Demi-Sec ou Moscatel", just:"Doçura compatível com a sobremesa; acidez da fruta ajuda o equilíbrio.", temp:"4–6 °C", metodo:"Asti ou Charmat", prods:["moscatel"], col:"espumantes"},
  "coco-chocolate":{estilo:"Moscatel (inclusive rosé)", just:"Só um espumante realmente doce acompanha coco e chocolate sem ficar amargo.", temp:"4–6 °C", metodo:"Asti", prods:["moscatel"], col:"espumantes"},
  "choc-amargo":{estilo:"Moscatel rosé (desafio!)", just:"Chocolate amargo é difícil para espumantes; se insistir, fruta vermelha e dulçor — ou prefira um fortificado.", temp:"4–6 °C", metodo:"Asti", prods:["moscatel"], col:"espumantes"},
  natal:{estilo:"Moscatel", just:"O par natalino por excelência: panetone, rabanada e frutas cristalizadas.", temp:"4–6 °C", metodo:"Asti", prods:["moscatel"], col:"caixas"}
};
var harmSel = $("#harm-prato"), harmRes = $("#harm-resultado");
if(harmSel){
  harmSel.addEventListener("change", async function(){
    var h = HARM[harmSel.value];
    if(!h){ harmRes.innerHTML=""; return; }
    var html = '<div class="dica"><p><strong>Estilo recomendado:</strong> '+h.estilo+'</p>'+
      '<p><strong>Por quê:</strong> '+h.just+'</p>'+
      '<p><strong>Temperatura:</strong> '+h.temp+' · <strong>Método sugerido:</strong> '+h.metodo+'</p></div>';
    html += '<div id="harm-produtos" aria-live="polite"><p class="prod-loading">Buscando produtos atuais na loja…</p></div>';
    var col = COLECOES[h.col];
    if(col){ html += '<p><a href="'+col.url+'" title="'+col.nome+'">Ver mais opções em: '+col.nome+' →</a></p>'; }
    harmRes.innerHTML = html;
    var produtosArea = $("#harm-produtos");
    var termos = termosBuscaProduto(h.estilo);
    try{
      var produtosLoja = await buscarProdutosLoja(termos,4);
      if(!produtosLoja.length){
        produtosArea.innerHTML = '<p>Não encontramos produtos disponíveis para esta busca agora. Use o link da coleção abaixo para ver outras opções.</p>';
        return;
      }
      produtosArea.innerHTML = '<p style="font-size:.9em"><strong>Sugestões atuais da loja</strong> · busca por “'+escProduto(termos.join('” e “'))+'”:</p><div class="prod-grid">'+produtosLoja.map(cardProdutoLoja).join("")+'</div>';
    }catch(erro){
      if(erro && erro.name==="AbortError") return;
      produtosArea.innerHTML = '<p>Não foi possível carregar os produtos agora. Use o link da coleção abaixo para continuar.</p>';
    }
  });
}


var quizForm = $("#quiz-form"), quizRes = $("#quiz-resultado");
var qAtual = 1, TOTALQ = 8;
function mostraQ(n){
  $$(".quiz-q").forEach(function(q){ q.classList.toggle("ativa", +q.getAttribute("data-q")===n); });
  $("#quiz-voltar").hidden = n<=1;
  $("#quiz-avancar").textContent = (n===TOTALQ) ? "Ver meu resultado ✓" : "Avançar →";
  $("#quiz-prog").style.width = ((n-1)/TOTALQ*100) + "%";
}
function resposta(n){
  var el = quizForm.querySelector('input[name="q'+n+'"]:checked');
  return el ? el.value : null;
}
$("#quiz-avancar").addEventListener("click", function(){
  if(!resposta(qAtual)){
    alert("Escolha uma opção para continuar.");
    return;
  }
  if(qAtual < TOTALQ){ qAtual++; mostraQ(qAtual); }
  else { calculaQuiz(); }
});
$("#quiz-voltar").addEventListener("click", function(){ if(qAtual>1){ qAtual--; mostraQ(qAtual); } });

async function calculaQuiz(){
  var r = {};
  for(var i=1;i<=TOTALQ;i++){ r["q"+i]=resposta(i); }
  // pontuação de doçura: q1, q2, q3(uva), q4(sobremesa)
  var doce = 0;
  if(r.q1==="doce") doce+=2; if(r.q1==="meio") doce+=1;
  if(r.q2==="doce") doce+=2; if(r.q2==="meio") doce+=1;
  if(r.q3==="uva") doce+=2;
  if(r.q4==="sobremesa") doce+=1;
  var semAlcool = r.q7==="sem";
  var complexo = r.q6==="complexo" || r.q3==="pao";
  var rose = r.q5==="rose";

  var perfil, docura, metodo, estilo, harmonias, ocasioes, estilosProd, colecoes;
  if(semAlcool){
    perfil = "Brinde inclusivo";
    docura = "Frutado, geralmente adocicado";
    metodo = "Elaborações 0,0% (confira o rótulo)";
    estilo = rose ? "Espumante sem álcool rosé" : "Espumante sem álcool";
    harmonias = "frutas, saladas, sobremesas leves e petiscos de tarde";
    ocasioes = "gestações, direção, escolha pessoal — qualquer brinde em que todos participam";
    estilosProd = ["semalcool"];
    colecoes = ["semalcool"];
  } else if(doce >= 4){
    perfil = "Alma doce e aromática";
    docura = "Doce (Moscatel) ou Demi-Sec";
    metodo = "Asti";
    estilo = rose ? "Moscatel rosé" : "Moscatel";
    harmonias = "sobremesas, frutas, queijos azuis, panetone e pratos levemente picantes";
    ocasioes = "brunches, tardes de verão, Natal, festas e mesas de doces";
    estilosProd = ["moscatel"];
    colecoes = ["espumantes"];
  } else if(doce >= 2){
    perfil = "Equilibrista frutado";
    docura = "Brut a Sec — seco com maciez";
    metodo = "Charmat";
    estilo = rose ? "Brut Rosé ou Sec rosé" : "Brut ou Sec de perfil frutado";
    harmonias = "pizzas, massas ao tomate, frango assado, comida asiática suave";
    ocasioes = "almoços de fim de semana, encontros informais, churrasco";
    estilosProd = ["brut-tradicional","moscatel"];
    colecoes = ["espumantes","proseccos"];
  } else if(complexo){
    perfil = "Explorador de profundidade";
    docura = "Nature a Brut — o mais seco, melhor";
    metodo = "Tradicional (busque menções a 'sur lie')";
    estilo = rose ? "Brut Rosé de método tradicional ou Blanc de Noirs" : "Nature, Extra Brut ou Blanc de Blancs";
    harmonias = "ostras, risotos de cogumelo, queijos de casca florida, aves com molhos";
    ocasioes = "jantares gastronômicos, presentes especiais, celebrações íntimas";
    estilosProd = ["nature","brut-tradicional","kit"];
    colecoes = ["valduga","espumantes"];
  } else {
    perfil = "Frescor em primeiro lugar";
    docura = "Brut ou Extra Brut";
    metodo = "Charmat";
    estilo = rose ? "Brut Rosé" : "Brut jovem ou Prosecco brasileiro";
    harmonias = "aperitivos, frituras, sushi, saladas e frutos do mar";
    ocasioes = "praia, piscina, happy hour, consumo cotidiano";
    estilosProd = ["brut-tradicional"];
    colecoes = ["proseccos","espumantes"];
  }
  if(r.q8==="presente" && !semAlcool){ estilosProd.unshift("kit"); }

  var html = '<h4>Seu perfil: '+perfil+'</h4>'+
    '<p>Com base nas suas respostas, um espumante <strong>'+estilo+'</strong> provavelmente combina com você. Vale experimentar rótulos na faixa <strong>'+docura+'</strong>, de preferência elaborados pelo método <strong>'+metodo+'</strong>.</p>'+
    '<p><strong>Harmonizações para começar:</strong> '+harmonias+'.<br><strong>Ocasiões com a sua cara:</strong> '+ocasioes+'.</p>';
  var links = [];
  colecoes.forEach(function(c){ if(COLECOES[c]) links.push('<a href="https://espumantesdosul.com.br'+COLECOES[c].url+'" target="_blank" rel="noopener" title="'+COLECOES[c].nome+'">'+COLECOES[c].nome+'</a>'); });
  if(links.length){ html += '<p><strong>Categorias sugeridas:</strong> '+links.join(" · ")+'</p>'; }
  html += '<div id="quiz-produtos" aria-live="polite"><p class="prod-loading">Buscando produtos atuais para o seu perfil…</p></div>';
  html += '<div class="acoes"><button type="button" class="btn btn-outline" id="quiz-reset">Refazer o quiz</button></div>';
  quizForm.style.display = "none";
  $("#quiz-prog").style.width = "100%";
  quizRes.style.display = "block";
  quizRes.innerHTML = html;
  $("#quiz-reset").addEventListener("click", resetQuiz);
  quizRes.scrollIntoView({behavior:"smooth", block:"nearest"});
  var quizProdutosArea = $("#quiz-produtos");
  var termosQuiz = termosBuscaProduto(estilo);
  if(r.q8==="presente" && !semAlcool) termosQuiz.unshift("kit espumantes");
  try{
    var produtosQuiz = await buscarProdutosLoja(termosQuiz,4);
    if(!quizProdutosArea.isConnected) return;
    if(!produtosQuiz.length){
      quizProdutosArea.innerHTML = '<p>Não encontramos produtos disponíveis para este perfil agora. Use as categorias sugeridas acima para continuar explorando.</p>';
      return;
    }
    quizProdutosArea.innerHTML = '<p><strong>Produtos atuais que combinam com seu perfil</strong> · busca por “'+escProduto(termosQuiz.join('” e “'))+'”:</p><div class="prod-grid">'+produtosQuiz.map(cardProdutoLoja).join("")+'</div>';
  }catch(erro){
    if(erro && erro.name==="AbortError") return;
    if(quizProdutosArea.isConnected) quizProdutosArea.innerHTML = '<p>Não foi possível carregar os produtos agora. Use as categorias sugeridas acima para continuar.</p>';
  }
}
function resetQuiz(){
  if(buscaProdutosController) buscaProdutosController.abort();
  quizForm.reset();
  qAtual = 1;
  quizForm.style.display = "";
  quizRes.style.display = "none";
  quizRes.innerHTML = "";
  mostraQ(1);
}
var btnRefazer = $("#refazer-quiz");
if(btnRefazer){
  btnRefazer.addEventListener("click", function(){
    resetQuiz();
    document.getElementById("quiz").scrollIntoView({behavior:"smooth"});
  });
}
mostraQ(1);


$("#c-calcular").addEventListener("click", function(){
  var conv = Math.max(1, parseInt($("#c-convidados").value,10) || 0);
  var dur = Math.max(1, parseFloat($("#c-duracao").value) || 0);
  var tipo = $("#c-tipo").value;
  var outras = $("#c-outras").value;
  var perfil = $("#c-perfil").value;
  var mlGarrafa = parseInt($("#c-garrafa").value,10);
  var margem = parseFloat($("#c-margem").value) || 1.10;
  var caixas = $("#c-caixas").checked;

  // consumo base em taças de ~130 ml por pessoa/hora, conforme o tipo de evento
  var taxa = {brinde:0, aperitivo:1.0, festa:0.8, jantar:0.7, casamento:0.9, formatura:1.0, corporativo:0.6}[tipo];
  var taças;
  if(tipo==="brinde"){ taças = 1; }
  else {
    taças = taxa * dur;
    // primeira hora consome mais; horas longas, menos
    if(dur>4) taças = taxa*4 + taxa*0.5*(dur-4);
  }
  var fatorOutras = {sim:0.6, poucas:0.8, nao:1.0}[outras];
  var fatorPerfil = {leve:0.8, medio:1.0, alto:1.25}[perfil];
  if(tipo!=="brinde") taças = taças * fatorOutras * fatorPerfil;
  var mlTotal = conv * taças * 130;
  var garrafas = Math.ceil(mlTotal * margem / mlGarrafa);
  if(tipo==="brinde"){ garrafas = Math.ceil(conv * 140 * margem / mlGarrafa); }
  garrafas = Math.max(1, garrafas);
  var exibidas = garrafas;
  var notaCaixa = "";
  if(caixas && mlGarrafa>=660){
    exibidas = Math.ceil(garrafas/6)*6;
    notaCaixa = " (" + (exibidas/6) + " caixa(s) de 6)";
  }
  var tacasFisicas = Math.ceil(conv * 1.15); // taças + reposição
  var gelo = Math.ceil(exibidas * 1.2); // ~1,2 kg por garrafa em baldes
  var caixasQtd = mlGarrafa>=660 ? Math.ceil(exibidas/6) : 0;
  var totalLitros = Math.round(exibidas * mlGarrafa / 100) / 10;
  var estilos = (tipo==="casamento"||tipo==="formatura")
    ? "Brut para a festa + Moscatel para os doces"
    : (tipo==="jantar" ? "método tradicional para os pratos e Moscatel para a sobremesa" : "Brut como base, com algumas garrafas de Moscatel e rosé para variar");

  $("#c-resultado").innerHTML =
    '<div class="dica"><h3>Planejamento estimado do evento</h3><div class="calc-summary">'+
    '<div class="calc-stat"><b>'+exibidas+'</b>garrafas de '+mlGarrafa+' ml</div>'+
    '<div class="calc-stat"><b>'+totalLitros+' L</b>volume total</div>'+
    '<div class="calc-stat"><b>'+tacasFisicas+'</b>taças disponíveis</div>'+
    '<div class="calc-stat"><b>'+gelo+' kg</b>gelo para baldes</div></div>'+
    '<p><strong>Consumo calculado:</strong> aproximadamente '+Math.round(taças*10)/10+' taça(s) por convidado. '+
    (caixasQtd ? '<strong>Compra em caixas:</strong> '+caixasQtd+' caixa(s) de 6. ' : '')+
    (exibidas!==garrafas ? 'O cálculo bruto foi de '+garrafas+' garrafas e foi arredondado para caixas fechadas.' : '')+'</p>'+
    '<p><strong>Estilos sugeridos:</strong> '+estilos+'.</p>'+
    '<p><small>⚠️ Cálculo estimativo, baseado em médias de consumo de adultos. Considere o perfil real dos seus convidados e ajuste. Para compras em volume, veja as <a href="/collections/espumantes-em-caixa" title="Caixas de espumantes">caixas de espumantes</a>; para brindes individuais, os <a href="/collections/mini-espumantes" title="Mini espumantes">minis de 187 ml</a>.</small></p></div>';
});


$("#fd-limpar").addEventListener("click", function(){
  $$("#ficha-degustacao input, #ficha-degustacao textarea, #ficha-degustacao select").forEach(function(c){ c.value=""; });
});
$("#fd-imprimir").addEventListener("click", function(){
  guideRoot.classList.add("print-ficha");
  window.print();
  setTimeout(function(){ guideRoot.classList.remove("print-ficha"); }, 500);
});
window.addEventListener("afterprint", function(){ guideRoot.classList.remove("print-ficha"); });

$$('.copy-link').forEach(function(button){
  button.addEventListener('click',function(){
    var url = location.origin + location.pathname + '#' + button.getAttribute('data-alvo');
    var original = button.textContent;
    function done(){ button.textContent='Copiado!'; setTimeout(function(){ button.textContent=original; },1600); }
    if(navigator.clipboard) navigator.clipboard.writeText(url).then(done);
    else window.prompt('Copie o link:',url);
  });
});
})();
